/**
 * [ File :: B_Proton.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/base/dev/animate/proton/B_Proton.js
 * @목적 : 분자단위 발산 애니메이션을 처리하기 위함
 * @진행 : 개발종료
 * @주의 : ProtonJS 이해가 선행
 * @이슈 : 없음
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 : https://a-jie.github.io/Proton/
 */

import BaseCanvas from 'canvas/base/dev/scripts/BaseCanvas'

const B_Proton = (function () {

	/**
	 * [STEP] Proton 다루기
	 *
	 * 01. let proton = new Proton :: 프로톤 객체 생성
	 * 02. let emitter = new Proton.Emitter(); :: 발산자 생성
	 * 03. emitter.addSomething(); :: 발산자 설정
	 * 04. emitter.emit(); :: 발산 시작
	 * 05. proton.addEmitter(emitter); :: 발산자 연결
	 * 06. let renderer = new Proton.Renderer(); :: 랜더자 생성
	 * 07. renderer.start(); :: 랜더링 시작
	 * 08. proton.update(); :: 업데이트
	 * 09. requestAnimationFrame(tick); :: 재귀함수
	 * 10. emitter.stopEmit(); :: 발산자 종료
	 * */

	// [D]
	const _active = new WeakMap();
	const _arrProton = new WeakMap();
	const _arrEmitter = new WeakMap();
	const _arrRenderer = new WeakMap();

	return class extends BaseCanvas {

		constructor(canvas) {
			super(canvas);

			// [S]
			_active.set(this, true);
			_arrProton.set(this, []);
			_arrEmitter.set(this, []);
			_arrRenderer.set(this, []);
		}

		// [V]

		// @DES :: arrProton[arr] - proton 객체 배열
		getArrProton() { return _arrProton.get(this); }
		setArrProton(ap) { _arrProton.set(this, ap); }

		// @DES :: arrEmitter[arr] - proton emitter 객체 배열
		getArrEmitter() { return _arrEmitter.get(this); }
		setArrEmitter(ae) { _arrEmitter.set(this, ae); }

		// @DES :: arrRenderer[arr] - proton renderer 객체 배열
		getArrRenderer() { return _arrRenderer.get(this); }
		setArrRenderer(ar) { _arrRenderer.set(this, ar); }

		// @DES :: active[bool] - proton 활성화 여부 객체
		getActive() { return _active.get(this); }
		setActive(a) { _active.set(this, a); }

	}
}());

export default B_Proton;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/animate/proton/B_Proton.js